import React, { useEffect, useState } from "react";
import pClasses from "../Test.module.scss";
import {
  faPlay,
  faCheckSquare,
  faSquare,
} from "@fortawesome/free-solid-svg-icons";
import * as iTest from "../../../interfaces/InterfacesTest";
import { useTranslation } from "react-i18next";
import ButtonsArea from "../../Buttons/ButtonsArea";
import RoundButton from "../../Buttons/RoundButton";
import * as h from "../../../helpers";
import Title from "../../Title";
import { useGlobalContext } from "../TestsContext/GlobalStateContext";
import { GET_AUDIO_DIR } from "../../../constants/tests";
import { keys } from "@mui/material/styles/createBreakpoints";

interface ButtonsAreaContent {
  test: iTest.InterfacesTest | null;
  activeTest: string;
  volume: number;
  testLevel: number;
  setResultsSon: (newValue: any) => void | null;
  setConfirmButtonAbleAux: (newValue: any) => void | null;
  setIsLastOneAux: (newValue: any) => void | null;
  btnClicked: boolean;
  setBtnClicked: (newValue: any) => void | null;
  setScoreRT: (newValue: any) => void | null;
  levelTextAuxRender: number;
}

export default function ButtonsAreaContent({
  test = null as iTest.InterfacesTest | null,
  activeTest,
  volume,
  testLevel,
  setResultsSon,
  setConfirmButtonAbleAux,
  setIsLastOneAux,
  btnClicked,
  setBtnClicked,
  setScoreRT,
  levelTextAuxRender,
}: ButtonsAreaContent) {
  const [tempAnswer, setTempAnswer] = useState({} as any);
  const [correctAnswers, setCorrectAnswers] = useState({} as any);
  const [hasPlayedAudio, setHasPlayedAudio] = useState(false);
  const [paused, setPause] = useState(false);
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const [scoreLevel, setScoreLevel] = useState(0);

  const {
    score,
    setScore,
    arrayAnswers,
    setArrayAnswers,
    arrayCorrects,
    setArrayCorrects,
    arrayMiscellaneousCount,
    setMiscellaneousCount,
    globalMiscellaneous,
    setGlobalMiscellaneous,
  } = useGlobalContext();

  // const howManyQuestions = 1;
  const { t } = useTranslation();
  const { levels, setup, multi_options, list_options, levels_text } =
    test as iTest.InterfacesTest;
  const { text, audio, correct, options } = levels[
    testLevel
  ] as iTest.InterfacesLevel;

  const setTempAnswerHandler = (
    option: string | number,
    correct: string | number
  ) => {
    const auxLevelAnswer = { ...tempAnswer };
    let listTestLevel = auxLevelAnswer[levelTextAuxRender] ?? [];
    const listCorrectAnswer = [];
    listCorrectAnswer.push(correct);
    if (!listTestLevel.includes(option)) {
      listTestLevel.push(option);
    } else {
      listTestLevel = listTestLevel.filter((opt: string) => opt !== option);
    }
    setTempAnswer({ ...auxLevelAnswer, [levelTextAuxRender]: listTestLevel });
    if (String(activeTest) === "dicotico_sequencial") {
      setArrayCorrects({ ...arrayCorrects, [testLevel]: [listCorrectAnswer] });
    } else {
      setCorrectAnswers({
        ...correctAnswers,
        [levelTextAuxRender]: listCorrectAnswer,
        score,
      });
    }
    if (String(activeTest) === "resolucao_temporal")
      if (
        String(correct) === String(option) &&
        String(activeTest) === "resolucao_temporal"
      ) {
        // setScore(score + 1)
        setArrayAnswers({
          ...arrayAnswers,
          [levelTextAuxRender]: [String(option)],
        });
        if (String(activeTest) === "resolucao_temporal") {
          setMiscellaneousCount({
            ...arrayMiscellaneousCount,
            [levelTextAuxRender]: String(audio).split("_")[1].split("m")[0],
          });
        }
      } else {
        setArrayAnswers({
          ...arrayAnswers,
          [levelTextAuxRender]: [String(option).split("_")[1]],
        });
        if (String(activeTest) === "resolucao_temporal") {
          setMiscellaneousCount({
            ...arrayMiscellaneousCount,
            [levelTextAuxRender]: "",
          });
        }
      }
    checkScore(checkTempAnswers(tempAnswer), checkCorrects(correctAnswers));
    setResultsSon(scoreToPass);
  };

  const normalizeOption = (index: string | number, option: string | number) => {
    return String(index) + String("_") + String(option);
  };

  const getIndexes = (
    indexList: string | number,
    subIndex?: string | number | null
  ) => {
    return "ID_" + indexList + "_" + (subIndex ? subIndex + "_" : "");
  };

  const getBtnsBySelectedOptions = (
    listOptions = null as iTest.OptionsType,
    options = null as iTest.OptionsType,
    correct = "" as string | number
  ) => {
    let _btns = null as any;
    if (listOptions && options && correct) {
      _btns = [];
      let tempCorrect = "" as any;
      if (correct) tempCorrect = listOptions[parseInt(String(correct))];
      options.forEach((key, index) => {
        if (key) {
          const tempOption = listOptions[parseInt(String(key))];
          if (tempOption) {
            _btns.push(getBtnOptionTagHandler(tempOption, tempCorrect, index));
          }
        }
      });
    }
    return _btns;
  };
  const getBtnsBySelectedOptionsDicoticoSequencial = (
    listOptions = null as any,
    options = null as iTest.OptionsType,
    correct = null as any
  ) => {
    let _btns = null as any;
    if (listOptions && options && correct) {
      _btns = [];
      const tempCorrect = [] as any;
      correct.forEach((key: any, index: any) => {
        tempCorrect.push(listOptions[key]);
        if (arrayCorrects) {
          if (
            tempCorrect.length === 4 &&
            Number(arrayCorrects.length) <= testLevel - 1
          ) {
            setArrayCorrects({
              ...arrayCorrects,
              [index * testLevel]: tempCorrect,
            });
          }
        }
      });
      // tempCorrect = listOptions[parseInt(String(correct))];
      options.forEach((key, index) => {
        if (key) {
          const tempOption = listOptions[parseInt(String(key))];
          if (tempOption) {
            _btns.push(
              getBtnOptionTagHandler(
                tempOption,
                tempCorrect,
                index,
                false,
                false,
                false,
                key
              )
            );
          }
        }
      });
    }
    return <div className={pClasses.fiveColumnBtns}>{_btns}</div>;
  };

  const getBtnsMultiOptions = (
    multiOptions = null as iTest.multiOptionsType, // Recebe um array de colunas com opções
    correct = "" as string | number // Valor correto, usado para destacar ou validar respostas
  ) => {
    const _btns = [] as any; // Array que armazenará todos os grupos de botões por coluna

    if (multiOptions) {
      // Verifica se existem opções
      // Pega as respostas já selecionadas pelo usuário no nível atual do teste
      const answeredColumns = tempAnswer[testLevel] || [];

      // Define qual coluna está liberada para seleção (próxima coluna após as respondidas)
      const activeColumn = answeredColumns.length;

      // Percorre cada coluna de opções
      multiOptions.forEach((listOptions, indexList) => {
        const _columnBtns = [] as any; // Array que armazenará os botões dessa coluna

        if (listOptions) {
          // Percorre cada opção da coluna
          listOptions.forEach((option, indexOption) => {
            if (option) {
              // Cria um identificador único para cada opção
              const indexLevel = getIndexes(indexList, indexOption);

              let isDisable = false; // Indica se o botão estará desabilitado

              // Se a coluna ainda não é a vez dela, desativa os botões
              if (indexList > activeColumn) {
                // Desativa todos os botões dessa coluna
                isDisable = true;
              }
              // Se já tem respostas para este nível do teste
              else if (tempAnswer[testLevel]) {
                // Verifica cada resposta selecionada
                tempAnswer[testLevel].forEach((ans: string) => {
                  // Se a resposta inclui esta coluna
                  if (ans.includes(getIndexes(indexList))) {
                    // Se a resposta está nesta coluna, desativa o botão
                    isDisable = true;
                    // Mas se a resposta for exatamente esta opção, mantém o botão ativo
                    if (ans.includes(normalizeOption(indexLevel, option))) {
                      isDisable = false;
                    }
                  }
                });
              }

              // Cria o botão chamando a função de geração de botão
              _columnBtns.push(
                getBtnOptionTagHandler(
                  option, // Texto ou valor da opção
                  correct, // Valor correto para validação
                  indexLevel, // ID único da opção
                  false, // Parâmetro fixo
                  true, // Parâmetro fixo
                  isDisable // Define se o botão está habilitado ou não
                )
              );
            }
          });

          // Se houver botões na coluna, adiciona o grupo de botões no array principal
          if (_columnBtns.length > 0)
            _btns.push(
              <>
                <div
                  className={pClasses.ColumnBtnsArea} // Container da coluna
                  key={h.keyGenerator(_columnBtns.length)} // Gera uma chave única
                >
                  <div className={pClasses.ColumnBtnsTitle}>
                    {indexList + 1}° SOM
                  </div>
                  <ButtonsArea vert className={pClasses.ColumnBtns}>
                    {_columnBtns} {/* Renderiza todos os botões da coluna */}
                  </ButtonsArea>
                </div>
              </>
            );
        }
      });
    }
    // Retorna todos os grupos de botões já organizados por coluna
    return _btns;
  };

  const getBtnsAllOptions = (
    listOptions = null as iTest.OptionsType,
    correct = "" as string | number
  ) => {
    let _btns = null as any;
    if (listOptions) {
      _btns = [];
      listOptions.forEach((option, index) => {
        if (option) {
          _btns.push(getBtnOptionTagHandler(option, correct, index, true));
        }
      });
    }
    return _btns;
  };

  const getBtnsAllOptionsFourOptions = (
    listOptions = null as iTest.OptionsType,
    correct = "" as string | number
  ) => {
    let _btns = null as any;
    if (listOptions) {
      _btns = [];
      listOptions.forEach((option, index) => {
        if (option) {
          _btns.push(
            getBtnOptionTagHandler(option, correct, index, true, true)
          );
        }
      });
    }
    return _btns;
  };

  const [playOrPause, setPlayOrPause] = useState(false);
  const [mayFastAnswer, setMayFastAnswer] = useState(true);
  const playing = new Audio(GET_AUDIO_DIR(activeTest, audio));
  try {
    if (volume) playing.volume = volume / 100;
  } catch (error) {
    console.error("[Error to set volume]", error);
  }

  const toggle = () => {
    if (playOrPause) setPlayOrPause(false);
    else setPlayOrPause(true);
  };

  useEffect(() => {
    playOrPause ? playing.play() : playing.pause();
  }, [playOrPause]);
  useEffect(() => {
    if (
      activeTest === "dicotico_sequencial" ||
      activeTest === "dicoticos_oe" ||
      activeTest === "dicoticos_od" ||
      activeTest === "ordenacao_temporal"
    ) {
      setMayFastAnswer(false);
    }
    playing.addEventListener("ended", () => setPlayOrPause(false));
    return () => {
      playing.removeEventListener("ended", () => setPlayOrPause(false));
    };
  }, []);
  playing.addEventListener("pause", () => setIsPlayingAudio(false));

  const getBtnOptionTagHandler = (
    option = "" as string | number,
    correct = "" as string | number,
    indexLevel = "" as string | number,
    isShowAll = false as boolean,
    isMultiOptions = false as boolean,
    isDisable = false as boolean,
    key = "" as string | number
  ) => {
    let hasLimitCheck = false;
    let isChecked = false;
    let className = pClasses.BtnOption;
    if (isShowAll) className += " " + pClasses.BtnOptionShowAll;

    if (tempAnswer && tempAnswer[testLevel]) {
      isChecked = tempAnswer[testLevel].includes(
        normalizeOption(indexLevel, option)
      );
      if (
        (isShowAll && isMultiOptions) ||
        activeTest === "dicotico_sequencial"
      ) {
        hasLimitCheck = tempAnswer[testLevel].length >= 4;
      } else if (isMultiOptions) {
        hasLimitCheck = tempAnswer[testLevel].length >= 3;
      } else if (isShowAll) {
        hasLimitCheck = tempAnswer[testLevel].length >= 2;
      } else {
        hasLimitCheck = tempAnswer[testLevel].length === 1;
      }
    }
    if (isChecked) className += " " + pClasses.BtnOptionSelected;
    let keyAux: any = [];
    keyAux = correct;
    return option !== "" ? (
      <RoundButton
        key={h.keyGenerator(option)}
        outline
        center
        small
        disabled={
          !hasPlayedAudio ||
          (hasLimitCheck && !isChecked) ||
          isDisable ||
          (!mayFastAnswer ? isPlayingAudio : false)
        }
        secondary={!isChecked}
        faIcon={isChecked ? faCheckSquare : faSquare}
        className={className}
        text={t("tests." + option)}
        title={t("global.select_answer") + ": " + t("tests." + option)}
        onClick={() => {
          setBtnClicked(false);
          setTempAnswerHandler(
            normalizeOption(indexLevel, option),
            normalizeOption(indexLevel, correct)
          );
          if (key && option && keyAux && activeTest === "dicotico_sequencial") {
            if (Object.values(keyAux).includes(String(option))) {
              setMiscellaneousCount({
                ...arrayMiscellaneousCount,
                [key]: key,
              });
            }
            if (Object.values(arrayMiscellaneousCount).includes(key)) {
              setMiscellaneousCount({
                ...arrayMiscellaneousCount,
                [key]: "",
              });
            }
          }
          playing.pause();
          if (playOrPause) toggle();
        }}
      />
    ) : null;
  };

  const getButtonsOptionsHandler = (
    is_multi_options: boolean,
    show_all_options: boolean,
    multiOptions: iTest.multiOptionsType,
    listOptions: iTest.OptionsType,
    options: iTest.OptionsType,
    correct: any
  ) => {
    let _btns = [] as any;
    if (
      !multiOptions &&
      typeof listOptions === "object" &&
      is_multi_options &&
      show_all_options
    ) {
      _btns = getBtnsAllOptionsFourOptions(listOptions, correct);
    } else if (
      is_multi_options &&
      multiOptions &&
      typeof multiOptions === "object"
    ) {
      _btns = getBtnsMultiOptions(multiOptions, correct);
    } else if (show_all_options) {
      _btns = getBtnsAllOptions(listOptions, correct);
    } else if (activeTest === "dicotico_sequencial") {
      _btns = getBtnsBySelectedOptionsDicoticoSequencial(
        listOptions,
        options,
        correct
      );
    } else {
      _btns = getBtnsBySelectedOptions(listOptions, options, correct);
    }
    return _btns;
  };

  // function to mount an object with all users answers for active test
  const checkTempAnswers = (tempAnswer: any) => {
    const auxAnswers = [] as any;
    const tempAnswerLength = Object.getOwnPropertyNames(tempAnswer).length;

    if (String(activeTest) !== "resolucao_temporal") {
      for (let i = 0; i < tempAnswerLength; i++) {
        if (tempAnswer[i]) {
          for (let j = 0; j < 4; j++) {
            if (activeTest === "dicotico_sequencial") {
              if (tempAnswer[i][j]) {
                tempAnswer
                  ? (auxAnswers[0] = tempAnswer)
                  : (auxAnswers[0] = "");

                setArrayAnswers(tempAnswer);
              }
            } else {
              //for dicótico oeod (four answers)
              if (tempAnswer[i][j] && tempAnswer[i].length === 4) {
                tempAnswer[i][j][0]
                  ? auxAnswers.push(tempAnswer[i][j][0])
                  : auxAnswers.push([]);

                setArrayAnswers({
                  ...arrayAnswers,
                  [i]: [
                    auxAnswers[i * 4],
                    auxAnswers[i * 4 + 1],
                    auxAnswers[i * 4 + 2],
                    auxAnswers[i * 4 + 3],
                  ],
                });
              }
              if (tempAnswer[i][j] && tempAnswer[i].length === 3) {
                //for ordenação temporal (three answers)
                tempAnswer[i][j][5]
                  ? auxAnswers.push(tempAnswer[i][j][5])
                  : auxAnswers.push(["x"]);
                setArrayAnswers({
                  ...arrayAnswers,
                  [i]: [
                    auxAnswers[i * 3],
                    auxAnswers[i * 3 + 1],
                    auxAnswers[i * 3 + 2],
                  ],
                });
              }
              if (tempAnswer[i].length === 2) {
                //for every test with 2 answers
                let auxParse = [];
                if (tempAnswer[i][0][0]) auxParse = tempAnswer[i][0][0];
                let auxParse2 = [];
                if (tempAnswer[i][0][0]) auxParse2 = tempAnswer[i][1][0];
                auxAnswers[i * 2] = auxParse;
                auxAnswers[i * 2 + 1] = auxParse2;
                setArrayAnswers({
                  ...arrayAnswers,
                  [i]: [auxParse, auxParse2],
                });
              }
              if (tempAnswer[i].length === 1) {
                //for every test with one answer, except resolução temporal
                let auxSplit = [];
                if (tempAnswer[i][0][0])
                  auxSplit = tempAnswer[i][0].split("_")[1];
                auxAnswers[i] = auxSplit;
                setArrayAnswers({ ...arrayAnswers, [i]: [auxSplit] });
              }
            }
          }
        }
      }
    } else if (String(activeTest) === "resolucao_temporal") {
      let auxSplit = "";
      if (tempAnswer[levelTextAuxRender])
        auxSplit = String(tempAnswer[levelTextAuxRender]).split("_")[1];
      auxAnswers.push(auxSplit);
    }
    return auxAnswers;
  };
  // function to mount an object with all correct answers for active test
  const checkCorrects = (correctAnswers: any) => {
    const auxCorrects = [] as any;
    const tempAnswerLength = Object.getOwnPropertyNames(tempAnswer).length;
    if (String(activeTest) !== "resolucao_temporal") {
      for (let i = 0; i < tempAnswerLength; i++) {
        if (tempAnswer[i] && correctAnswers[i]) {
          for (let j = 0; j < 3; j++) {
            if (
              activeTest === "dicotico_sequencial" &&
              tempAnswer[i][j] &&
              tempAnswer[i].length === 4 &&
              j === 0
            ) {
              auxCorrects.push(correctAnswers[testLevel]);
              setArrayCorrects({ ...arrayCorrects, [i]: auxCorrects });
            } else {
              if (tempAnswer[i][j] && tempAnswer[i].length === 4 && j === 0) {
                auxCorrects.push([correctAnswers[i][0].split("_")[1]]);
                setArrayCorrects({
                  ...arrayCorrects,
                  [i]: [
                    auxCorrects[i * 4],
                    auxCorrects[i * 4 + 1],
                    auxCorrects[i * 4 + 2],
                    auxCorrects[i * 4 + 3],
                  ],
                });
              }
              if (tempAnswer[i][j] && tempAnswer[i].length === 3) {
                auxCorrects.push(correctAnswers[i][0][8 + j * 2]);
                setArrayCorrects({
                  ...arrayCorrects,
                  [i]: [
                    auxCorrects[i * 3],
                    auxCorrects[i * 3 + 1],
                    auxCorrects[i * 3 + 2],
                  ],
                });
              }
              if (tempAnswer[i].length === 2 && j === 0) {
                const auxParse = [
                  correctAnswers[i][0][2],
                  correctAnswers[i][0][4],
                ];
                if (auxParse[0] && auxParse[1]) auxCorrects[i] = auxParse;
                if (auxParse[0] && auxParse[1])
                  setArrayCorrects({ ...arrayCorrects, [i]: [auxParse] });
              }
              if (tempAnswer[i].length === 1 && j === 0) {
                const auxSplit = correctAnswers[i][0].split("_")[1];
                if (tempAnswer[i][j] && tempAnswer[i].length === 1)
                  auxCorrects.push(auxSplit);
                if (tempAnswer[i][j] && tempAnswer[i].length === 1)
                  setArrayCorrects({ ...arrayCorrects, [i]: [auxSplit] });
              }
            }
          }
        }
      }
    } else if (String(activeTest) === "resolucao_temporal") {
      let auxSplit = "";
      if (correctAnswers[levelTextAuxRender])
        auxSplit = String(correctAnswers[levelTextAuxRender]).split("_")[1];
      setArrayCorrects({ ...arrayCorrects, [levelTextAuxRender]: [auxSplit] });
      auxCorrects.push(auxSplit);
    }
    return auxCorrects;
  };
  // function to count the number of correct answers (except for resolucao_temporal, it is done in Users\Tests\Tests)
  const checkScore = (auxAnswers: any, auxCorrects: any) => {
    let cont = 0;
    let contAux = 0;
    const tempAnswerLength = Object.getOwnPropertyNames(tempAnswer).length;
    if (String(activeTest) !== "resolucao_temporal") {
      for (let i = 0; i < tempAnswerLength; i++) {
        if (tempAnswer[i] && correctAnswers[i]) {
          for (let j = 0; j < 3; j++) {
            if (tempAnswer[i][j] && tempAnswer[i].length === 4 && j === 0) {
              auxCorrects.push([correctAnswers[i][0].split("_")[1]]);
            }
            if (tempAnswer[i][j] && tempAnswer[i].length === 3) {
              auxCorrects.push(correctAnswers[i][0][8 + j * 2]);
            }
            if (tempAnswer[i].length === 2 && j === 0) {
              const auxParse = [
                correctAnswers[i][0][2],
                correctAnswers[i][0][4],
              ];
              if (auxParse[0] && auxParse[1]) auxCorrects[i] = auxParse;
            }
            if (tempAnswer[i].length === 1 && j === 0) {
              const auxSplit = correctAnswers[i][0].split("_")[1];
              if (tempAnswer[i][j] && tempAnswer[i].length === 1)
                auxCorrects.push(auxSplit);
            }
          }
        }
      }
      for (let i = 0; i < tempAnswerLength; i++) {
        if (tempAnswer[i] && correctAnswers[i]) {
          if (activeTest === "dicotico_sequencial") {
            setArrayCorrects(auxCorrects[1]);
          } else {
            if (tempAnswer[i].length === 4) {
              const arrayAuxAnswers = [
                auxAnswers[i * 4],
                auxAnswers[i * 4 + 1],
                auxAnswers[i * 4 + 2],
                auxAnswers[i * 4 + 3],
              ];
              const arrayAuxCorrects = [];
              arrayAuxCorrects[i] = [auxCorrects[i][0].split(",")];
              const equalAnswers = arrayAuxCorrects[i][0].filter(
                (item: any) => arrayAuxAnswers.indexOf(item) !== -1
              );
              if (equalAnswers.length === arrayAuxCorrects[i][0].length) {
                cont++;
              }
              if (equalAnswers.length === arrayAuxCorrects[i][0].length)
                setScore(0);
            }
            if (tempAnswer[i].length === 3 && auxCorrects.length >= 3) {
              const arrayAuxAnswers = [
                auxAnswers[i * 3],
                auxAnswers[i * 3 + 1],
                auxAnswers[i * 3 + 2],
              ];
              const arrayAuxCorrects = [
                auxCorrects[i * 3],
                auxCorrects[i * 3 + 1],
                auxCorrects[i * 3 + 2],
              ];
              if (arrayAuxAnswers.toString() === arrayAuxCorrects.toString()) {
                contAux = 1;
                if (String(activeTest) === "ordenacao_temporal") {
                  setMiscellaneousCount({
                    ...arrayMiscellaneousCount,
                    [levelTextAuxRender]: String(audio)
                      .split("_")[1]
                      .split("_")[0],
                  });
                }
              } else {
                contAux = 0;
                if (String(activeTest) === "ordenacao_temporal") {
                  setMiscellaneousCount({
                    ...arrayMiscellaneousCount,
                    [levelTextAuxRender]: "",
                  });
                }
              }
              if (contAux === 1 && arrayAuxAnswers.length === 3) {
                cont++;
                setScore(0);
                contAux = 0;
              }
            }
            if (tempAnswer[i].length === 2) {
              const equalAnswers = [
                auxCorrects[i][0],
                auxCorrects[i][1],
              ].filter(
                (item: any) =>
                  [auxAnswers[i * 2], auxAnswers[i * 2 + 1]].indexOf(item) !==
                  -1
              );
              if (equalAnswers.length === 2) cont++;
              if (equalAnswers.length === 2) setScore(0);
            }
            if (tempAnswer[i].length === 1 && correctAnswers[i].length === 1) {
              if (auxAnswers[i].toString() === auxCorrects[i].toString())
                cont++;
              if (auxAnswers[i].toString() === auxCorrects[i].toString())
                setScore(0);
            }
          }
        }
      }
    }
    setScoreLevel(cont);
    return cont;
  };

  // const { levels, setup, multi_options, list_options, levels_text } =
  //   test as iTest.InterfacesTest;
  // const { text, audio, correct, options } = levels[
  //   testLevel
  // ] as iTest.InterfacesLevel;
  const { is_multi_options, show_all_options } = setup;
  const _btns = getButtonsOptionsHandler(
    is_multi_options,
    show_all_options,
    multi_options,
    list_options,
    options,
    correct
  );

  let testLevelTile = levels_text;

  if (text) testLevelTile = text;
  let isLastOne = testLevel === levels.length - 1;
  if (String(activeTest) === "resolucao_temporal")
    isLastOne = testLevel === levels.length - 1;
  setIsLastOneAux(isLastOne);

  const checkTempAnswer = correctAnswers[testLevel];
  useEffect(() => {
    checkScore(checkTempAnswers(tempAnswer), checkCorrects(correctAnswers));
  }, [checkTempAnswer]);
  useEffect(() => {
    setIsPlayingAudio(false);
    setHasPlayedAudio(false);
    setPause(false);
  }, [testLevel]);

  const confirmButtonAbleAux =
    tempAnswer && tempAnswer[testLevel] && tempAnswer[testLevel].length > 0;
  setConfirmButtonAbleAux(confirmButtonAbleAux);
  const scoreToPass = scoreLevel;
  setResultsSon(scoreToPass);

  // Lógica para aplicar classes CSS baseado no teste ativo
  const optionsAreaClassName = 
    activeTest === "ordenacao_temporal"
      ? pClasses.OptionsAreaOrdenacaoTemporal
      : activeTest === "dicotico_sequencial"
      ? pClasses.OptionsAreaDicoticoSequencial
      : activeTest === "dicoticos_oe" || activeTest === "dicoticos_od"
      ? `${pClasses.OptionsArea} ${pClasses.OptionsAreaThreeColumns}`
      : activeTest === "fechamento_oe" || activeTest === "fechamento_od" || activeTest === "localizacao_sonora" || activeTest === "figura_fundo_od" || activeTest === "figura_fundo_oe"
      ? `${pClasses.OptionsArea} ${pClasses.OptionsAreaHorizontal}`
      : `${pClasses.OptionsArea} ${pClasses.OptionsAreaNoGrid}`;

  let _optionsArea = null;
  
  // Layout especial para ordenacao_temporal: 2 colunas (título+play | opções)
  if (activeTest === "ordenacao_temporal") {
    _optionsArea = (
      <div className={optionsAreaClassName}>
        <div className={pClasses.LeftContainer}>
          <h2 className={pClasses.OptionsAreaTitle}>
            {t("tests." + testLevelTile)}
          </h2>
          <ButtonsArea spaceAround className={pClasses.AreaBtns}>
            <RoundButton
              key={h.keyGenerator(testLevel)}
              className={pClasses.BtnPlayHuge}
              disabled={btnClicked || hasPlayedAudio}
              faIcon={faPlay}
              huge
              onClick={() => {
                toggle();
                setHasPlayedAudio(true);
                setBtnClicked(true);
                setIsPlayingAudio(true);
              }}
              title={t("global.play_audio_test")}
            />
          </ButtonsArea>
        </div>
        <ButtonsArea spaceAround className={pClasses.AreaBtnss}>
          {_btns}
        </ButtonsArea>
      </div>
    );
  } else if (activeTest === "dicotico_sequencial") {
    // Layout especial para dicotico_sequencial: 2 colunas (título+play | opções horizontais)
    _optionsArea = (
      <div className={optionsAreaClassName}>
        <div className={pClasses.LeftContainer}>
          <h2 className={pClasses.OptionsAreaTitle}>
            {t("tests." + testLevelTile)}
          </h2>
          <ButtonsArea spaceAround className={pClasses.AreaBtns}>
            <RoundButton
              key={h.keyGenerator(testLevel)}
              className={pClasses.BtnPlayHuge}
              disabled={btnClicked || hasPlayedAudio}
              faIcon={faPlay}
              huge
              onClick={() => {
                toggle();
                setHasPlayedAudio(true);
                setBtnClicked(true);
                setIsPlayingAudio(true);
              }}
              title={t("global.play_audio_test")}
            />
          </ButtonsArea>
        </div>
        <div className={pClasses.RightContainer}>
          {_btns}
        </div>
      </div>
    );
  } else {
    // Layout padrão para os outros testes
    _optionsArea = (
      <div className={optionsAreaClassName}>
        <h2 className={pClasses.OptionsAreaTitle}>
          {t("tests." + testLevelTile)}
        </h2>
        <ButtonsArea spaceAround className={pClasses.AreaBtns}>
          <RoundButton
            key={h.keyGenerator(testLevel)}
            className={pClasses.BtnPlayHuge}
            disabled={btnClicked || hasPlayedAudio}
            faIcon={faPlay}
            huge
            onClick={() => {
              toggle();
              setHasPlayedAudio(true);
              setBtnClicked(true);
              setIsPlayingAudio(true);
            }}
            title={t("global.play_audio_test")}
          />
        </ButtonsArea>
        <ButtonsArea spaceAround className={pClasses.AreaBtnss}>
          {_btns}
        </ButtonsArea>
      </div>
    );
  }
  
  return _optionsArea;
}